/** 1px 行高的网格里，区块要占多少行才能放下自身高度和列内间距。 */
export const resolveMasonryRowSpan = (borderBoxHeight, rowHeight, extraGap = 0) => {
	const unit = rowHeight > 0 ? rowHeight : 1;
	const total = Math.max(0, Number(borderBoxHeight) || 0) + Math.max(0, Number(extraGap) || 0);
	return Math.max(1, Math.ceil(total / unit));
};
